// extracted by mini-css-extract-plugin
module.exports = {"toggleBtnGroup":"ToggleBtnGroup_toggleBtnGroup__3-7hO","toggleBtn":"ToggleBtnGroup_toggleBtn__24HNV","selected":"ToggleBtnGroup_selected__1TQ0q","xs":"ToggleBtnGroup_xs__19m5q"};